import * as React from "react";
function SvgDislike(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M17.41 3.43a4 4 0 012.27.83 2.49 2.49 0 00.59.39l.23.1v9.86l-1.11 1-3.75 7a3.09 3.09 0 00-.44 1.84l.3 3.9a1.72 1.72 0 01-.85.23c-1.62 0-3-2.59-3-4.71a5.86 5.86 0 01.07-.88l.65-4.22H4.22a2 2 0 01-1.41-.59 1.78 1.78 0 01-.54-1.27A1.84 1.84 0 013 15.35l.76-.57-.83-.47a1.85 1.85 0 01.36-3.38l.85-.26-.53-.67a1.84 1.84 0 011.17-3l.85-.14-.4-.76A1.82 1.82 0 015 5.28a1.85 1.85 0 011.75-1.84h10.66m0-2H6.63A3.85 3.85 0 003 5.28v.31a3.86 3.86 0 00-1.65 4.18A3.85 3.85 0 00.75 15a3.83 3.83 0 00-.48 1.8 3.76 3.76 0 001.12 2.69 4 4 0 002.83 1.19H10l-.3 1.92a7.87 7.87 0 00-.09 1.18c0 3.17 2.14 6.71 5 6.71a3.73 3.73 0 001.87-.49l1.1-.63-.1-1.26-.3-3.9a1.09 1.09 0 010-.34 1.1 1.1 0 01.13-.31L21 16.84l.83-.71.7-.6V3.47l-1.17-.53-.23-.1-.13-.1a5.9 5.9 0 00-3.53-1.31z" />
      <path d="M30 3.22v14h-7.46v-14H30m0-2h-7.46a2 2 0 00-2 2v14a2 2 0 002 2H30a2 2 0 002-2v-14a2 2 0 00-2-2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDislike);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
